import { render, staticRenderFns } from "./ElementDeadlineTableColumn.vue?vue&type=template&id=597ff618&scoped=true"
import script from "./ElementDeadlineTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementDeadlineTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementDeadlineTableColumn.vue?vue&type=style&index=0&id=597ff618&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597ff618",
  null
  
)

export default component.exports